import { Group } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";

export interface DateRange {
  startDate?: string; // ISO — inclusive start of day
  endDate?: string; // ISO — inclusive end of day
}

// From/To pickers that emit a `{ startDate, endDate }` ISO range suitable for
// the backend list endpoints' createdAt range filters. Plugs into
// usePaginatedList `filters`.
export function ListDateRangeFilter({
  value,
  onChange,
}: {
  value: DateRange;
  onChange: (next: DateRange) => void;
}) {
  return (
    <Group gap="xs" align="flex-end">
      <DatePickerInput
        label="From"
        placeholder="Start date"
        clearable
        w={150}
        value={value.startDate ? new Date(value.startDate) : null}
        onChange={(d) =>
          onChange({ ...value, startDate: toStartIso(d as Date | null) })
        }
      />
      <DatePickerInput
        label="To"
        placeholder="End date"
        clearable
        w={150}
        value={value.endDate ? new Date(value.endDate) : null}
        onChange={(d) =>
          onChange({ ...value, endDate: toEndIso(d as Date | null) })
        }
      />
    </Group>
  );
}

function toStartIso(d: Date | null): string | undefined {
  if (!d) return undefined;
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x.toISOString();
}
function toEndIso(d: Date | null): string | undefined {
  if (!d) return undefined;
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x.toISOString();
}
